export default __webpack_public_path__ + "static/media/13.20199ac3.jpg";